import { render, staticRenderFns } from "./CreateModelPart.vue?vue&type=template&id=5a756bb4&"
import script from "./CreateModelPart.vue?vue&type=script&lang=js&"
export * from "./CreateModelPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports